export class CreationToolError extends Error {}
